module.exports = __webpack_public_path__ + "static/media/image_5.758ac643.png";